import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../../common';
import { BookingHistoryFacade } from '../../../booking-history/booking-history.facade';

@Injectable({
  providedIn: 'root',
})
export class UliItemBookingHistoryGuard {
  constructor(private bookingHistoryFacade: BookingHistoryFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    return loadStoreState(this.bookingHistoryFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.bookingHistoryFacade);
  }
}
